import React from 'react';
import { Link } from 'gatsby';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <span className="site-footer__mark" aria-hidden="true">P</span>
          <span className="site-footer__name">Pascal</span>
          <span className="site-footer__tag">Double-entry, understood by AI, approved by you.</span>
        </div>
        <nav className="site-footer__nav" aria-label="Footer">
          <Link to="/personal" className="site-footer__link">Personal</Link>
          <Link to="/business" className="site-footer__link">Business</Link>
          <Link to="/#a-desktop" className="site-footer__link">Desktop</Link>
          <Link to="/security" className="site-footer__link">Security</Link>
          <Link to="/docs" className="site-footer__link">Docs</Link>
          <Link to="/changelog" className="site-footer__link">Changelog</Link>
        </nav>
        <div className="site-footer__copy">© 2026 Pascal · pascal.finance</div>
      </div>
    </footer>
  );
}
